module.exports = __webpack_public_path__ + "img/voice-EN@2x.9eda3676.png";